import script from "./OrderConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderConfig.vue?vue&type=script&setup=true&lang=js"

import "./OrderConfig.vue?vue&type=style&index=0&id=92d2ffc0&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92d2ffc0"]])

export default __exports__